/** Установка srcset для изображений */
export function setImgScaling(container: HTMLElement | null) {
    const imageList = container?.getElementsByTagName('img');

    if (imageList) {
        Array.from(imageList).forEach(image => {
            image.srcset = `${image.src} 2x`;
        });
    }
}
